import { createContext } from 'react';
import { StaffNavLinkData } from './StaffLayout';

type Data = {
  routes: StaffNavLinkData[];
};

export const StaffRoutingContext = createContext<Data>({ routes: [] });
